// @flow
import React from 'react';
import Modal from 'Components/Modal';
import Carousel from 'Components/Carousel';

type Props = {
  isOpen: boolean,
  selectedItem: number,
  children: Node,
  onClose: () => void,
};

type State = {
  isOpen: boolean,
  selectedItem: number,
};

export default class GalleryModal extends React.Component<Props, State> {
  static defaultProps = {
    selectedItem: 0,
  };

  state = {
    isOpen: this.props.isOpen,
    selectedItem: this.props.selectedItem,
  };

  UNSAFE_componentWillReceiveProps = (props: Props) => {
    this.setState({ isOpen: props.isOpen, selectedItem: props.selectedItem });
  };

  render() {
    const children = React.Children.map(this.props.children, (child) => {
      return React.cloneElement(child, {
        detailView: true,
      });
    });

    return (
      <Modal isOpen={this.state.isOpen} onClose={this.props.onClose} gallery>
        <Carousel
          id="gallery-modal"
          selectedItem={this.state.selectedItem}
        >
          {children}
        </Carousel>
      </Modal>
    );
  }
}
